module.exports = __webpack_public_path__ + "static/media/sleek.31a663f4.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplaylist/src/less/skins/sleek.less
// module id = 848
// module chunks = 0